// extracted by mini-css-extract-plugin
export default {"stopwatch":"style_stopwatch__ImjlB"};